export interface Colors {
  neutral: {
    [key: number]: string
  }
  primary: {
    [key: number]: string
  }
  background: {
    body: string
    tooltip: string
    dialog: string
    article: string
  }
  text: {
    0: string
    1: string
  }
  secondary: string
  white: string
  black: string
  svg: {
    normal: string
    active: string
  }
  grey: {
    [key: number]: string
  }
  blue: {
    [key: number]: string
  }
  green: {
    [key: number]: string
  }
  red: {
    [key: number]: string
  }
  yellow: {
    [key: number]: string
  }
}

export default function colors(uiMode: 'light' | 'dark'): Colors {
  return {
    neutral: {
      50: '#F0F1F6',
      100: '#D9DDE6',
      200: '#C1C7D4',
      300: '#A8B0C1',
      400: '#949DB2',
      500: '#565656',
      600: '#727C91',
      700: '#606779',
      800: '#797979',
      900: '#323232',
    },
    primary: {
      100: '#dddddd',
      200: '#e3e3e3',
      300: '#161616',
      400: '#808080',
      500: '#121212',
      600: '#FFC400',
      700: '#F47E0A',
      800: '#bbbbbb',
      900: '#242424',
    },
    background: {
      body: uiMode === 'light' ? '#121212' : '#000', // '#130c5f',
      tooltip: '#5050A0',
      dialog: '#161616',
      article: '#121212',
    },
    text: {
      0: uiMode === 'light' ? '#fff' : '#000',
      1: uiMode === 'dark' ? '#fff' : '#3B3F4A',
    },
    white: '#ffffff',
    black: '#000000',
    svg: {
      normal: '#aaaaaa',
      active: '#ffffff',
    },
    grey: {
      0: 'rgba(255, 255, 255, 1)',
      10: 'rgba(255, 255, 255, 0.8)',
      50: 'rgba(255, 255, 255, 0.5)',
      100: 'rgba(255, 255, 255, 0.2)',
      200: 'rgba(255, 255, 255, 0.1)',
      400: 'rgba(128, 128, 128, 1)',
      500: 'rgba(187, 187, 187, 1)',
      600: 'rgba(170, 170, 170, 0.5)',
      700: 'rgba(0, 0, 0, 0.2)',
      800: 'rgba(0, 0, 0, 0.5)',
      900: 'rgba(0, 0, 0, 1)',
    },
    secondary: '#202020',
    blue: {
      1: '#5050A0',
      2: 'rgba(80, 80, 160, 0.95)',
      3: 'rgba(80, 80, 160, 0.5)',
      4: 'rgba(80, 80, 160, 0.2)',
    },
    yellow: {
      100: '#ffa800',
    },
    green: {
      100: '#20DE9A',
    },
    red: {
      100: '#f00',
      200: '#cf2c2c',
    },
  }
}
